import { IonButton, IonCol, IonIcon, IonCard } from "@ionic/react";
import "./CartProduct.scss";
import { CartItem } from "../../types/shop/cart.type";
import { preventOverflow } from "../../functions/string.functions";
import { trash } from "ionicons/icons";
import shoppingCartService from "../../services/shop/cart.service";
import { useAppContext, useAppContextUpdater } from "../../services/app-context.service";
import CartProductEdit from "./CartProductEdit";
import { Link } from "react-router-dom";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getPriceFactor, getProductImageUrl, getProductUrl } from "../../functions/product.functions";
import ProgressiveImg from "../ProgressiveImg";

type Props = {
    itemIndex: number
    cartItem: CartItem
}
const BDT = new Intl.NumberFormat('en-IN');
const CartProduct: React.FC<Props> = ({ itemIndex, cartItem }) => {
    const data = useAppContext()
    const SetData = useAppContextUpdater()
    const priceFactor = getPriceFactor(data.settings)
    function onUpdateCart() {
        data.cart = shoppingCartService.shoppingCart
        SetData({ ...data })
    }
    function onDelete(itemIndex: number) {
        shoppingCartService.removeItemFromCart(itemIndex,priceFactor)
        onUpdateCart()
    }
    return (
        <IonCol size="12">
            <IonCard className="checkout-item-card cart-item-card">
                <div className="card-image-container">
                    <Link to={getProductUrl(cartItem.item_id)}>
                        <ProgressiveImg 
                            src={getProductImageUrl(cartItem.imageUrl || cartItem.img || "", 80)} 
                            alt={cartItem.title} 
                        />
                    </Link>
                </div>

                <CartProductEdit className="card-details" itemIndex={itemIndex} cartItem={cartItem}>
                    <h3 className="item-title">{preventOverflow(cartItem.title, 40)}</h3>
                    <p className="item-variant">{cartItem.selectedSku.props_names}</p>
                    <div className="item-price-qty">
                        <span className="qty-tag">
                            Qty: <b>{cartItem.quantity}</b> 
                            <FontAwesomeIcon icon={faEdit} className="edit-icon" style={{ marginLeft: '6px', fontSize: '0.8rem', color: 'var(--ion-color-primary)' }} />
                        </span>
                        <span className="price-tag">৳{BDT.format(cartItem.unitPrice)}</span>
                    </div>
                    <div className="item-total">
                        <span>Total:</span>
                        <strong className="total-amount">৳{BDT.format(cartItem.itemTotal)}</strong>
                    </div>
                </CartProductEdit>

                <div className="cart-item-actions">
                    <IonButton fill="clear" onClick={() => onDelete(itemIndex)} className="delete-btn">
                        <IonIcon icon={trash} slot="icon-only" />
                    </IonButton>
                </div>
            </IonCard>
        </IonCol>
    );
}
export default CartProduct
